import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7913a36a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "product-item" };
const _hoisted_2 = { class: "product-item__info" };
const _hoisted_3 = { class: "product-item__image" };
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = { class: "product-item__name" };
const _hoisted_6 = { class: "product-item__details" };
const _hoisted_7 = { class: "product-item__price" };
const _hoisted_8 = { class: "product-item__amount" };
const _hoisted_9 = { class: "product-item__quantity" };
import { formatCurrency } from '@/utilities/formatters';
import ErrorLoadingImg from '@/assets/svgs/ErrorLoadingImg.svg';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerOrderDetailsProductItem',
    props: {
        product: {}
    },
    setup(__props) {
        const props = __props;
        const handleImgError = (event) => {
            const target = event.target;
            target.src = ErrorLoadingImg;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                            src: props.product.img,
                            alt: props.product.name,
                            onError: handleImgError
                        }, null, 40, _hoisted_4)
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("h4", _hoisted_5, _toDisplayString(props.product.name), 1),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('base-management.customer-activity.sku')) + ": " + _toDisplayString(props.product.sku), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('base-management.customer-activity.gender')) + ": " + _toDisplayString(props.product.gender), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('base-management.customer-activity.category')) + ": " + _toDisplayString(props.product.category), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('base-management.customer-activity.size')) + ": " + _toDisplayString(props.product.size), 1)
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(formatCurrency)(props.product.price)), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(props.product.quantity) + " " + _toDisplayString(_ctx.$tc('base-management.customer-activity.unit', props.product.quantity)), 1)
                ])
            ]));
        };
    }
});
